import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

// Components
import { WpPageLayout, WpPageBody } from 'Wpds/components/page-layout';
import { WpCard, WpCardBody } from 'Wpds/components/card';
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

// Styles
import './MeetingModeEnding.scss';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

const MeetingModeEnding = () => {
  const history = useHistory();
  const { isZoom } = useApp();

  const { workspaceId } = useParams();

  const handleViewClick = useCallback(() => {
    const route = PageUrlsConstants.HOME_PAGE;
    if (isZoom) {
      (window as any).zoomSdk.openUrl({ url: route });
    }
    history.push(route);
  }, [workspaceId, isZoom]);

  const handleViewNotesClick = useCallback(() => {
    const route = PageUrlsUtils.makeWorkspaceHistoryAgendaUrl(workspaceId);
    if (isZoom) {
      (window as any).zoomSdk.openUrl({ url: `${window.location.origin}${route}` });
    }
    history.push(route);
  }, [workspaceId, isZoom]);

  const baseClassName = 'MeetingModeEndingV2';
  return (
    <WpPageLayout className={baseClassName}>
      <WpPageBody>
        <div className={`${baseClassName}__content-wrapper`}>
          <div className={`${baseClassName}__content-wrapper__content`}>
            {isZoom && (
              <>
                <h5>Meeting Adjourned!</h5>
                <p>A meeting summary will be emailed to attendees</p>
              </>
            )}

            <WpCard centered>
              <WpCardBody padding={0}>
                <div className={`${baseClassName}__card__img`}>
                  <WpIllustration
                    className={`${baseClassName}__card__img__img`}
                    src={Illustrations.person_at_desk_in_video_call_with_purple_bg}
                  />
                </div>
              </WpCardBody>
              <WpCardBody>
                {isZoom ? (
                  <>
                    <p className={`${baseClassName}__card__title`}>Get ready for your next meeting</p>
                    <p className={`${baseClassName}__card__description`}>
                      View your workspace on PI Perform anytime to prepare for your next meeting.
                    </p>
                  </>
                ) : (
                  <>
                    <p className={`${baseClassName}__card__title`}>Meeting Adjourned!</p>
                    <p className={`${baseClassName}__card__description`}>
                      Meeting notes will be emailed to all workspace members
                    </p>
                  </>
                )}
                <WpButtonGroup stacked>
                  <WpButton block onClick={handleViewNotesClick} size="lg">
                    View Meeting Notes
                  </WpButton>
                  <WpButton block onClick={handleViewClick} size="lg" variant="secondary">
                    Back to Home
                  </WpButton>
                </WpButtonGroup>
              </WpCardBody>
            </WpCard>
          </div>
          <WpIllustration
            src={Illustrations.pi_logo_full_red_with_text}
            className={`${baseClassName}__logo-img`}
            alt="Predictive Index logo"
          />
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default MeetingModeEnding;
